<script>
    import SpotTypeSwitch from "./SpotTypeSwitch.svelte";
    import SpotsDisplay from "./SpotsDisplay.svelte";
    import Form from "./Form.svelte";

    import { sendEmailVerification } from "firebase/auth";

    import { onMount } from "svelte";
    import {
        rank,
        grade,
        spotMargin,
        spotType,
        spotTypeBeforeAPICall,
        startYear,
        userLoggedIn,
    } from "./Stores";
    import { spotTypes, fetchDataResults } from "./Constants";
    import { fetchDataFromServer } from "./ServerCommunications";

    export let appName;
    export let auth;

    let spotCards = null;
    let loading = true;
    let fetchDataResult = fetchDataResults.SUCCESS;

    let verificationEmailSent = false;

    const fetchData = async () => {
        let sendApiCall = true;
        if ($rank > 1 || $grade < 125) {
            if (!$userLoggedIn) {
                fetchDataResult = fetchDataResults.USER_NOT_LOGGED_IN;
                sendApiCall = false;
            } else if (!auth.currentUser.emailVerified) {
                fetchDataResult = fetchDataResults.USER_EMAIL_NOT_VERIFIED;
                sendApiCall = false;
            }
        }

        if (sendApiCall) {
            try {
                loading = true;
                const spotTypeBeforeAPICall_lock = $spotTypeBeforeAPICall;
                const viewPath =
                    spotTypeBeforeAPICall_lock === spotTypes.IFE
                        ? `spots?ranking=${$rank}&margin=${$spotMargin}&start_year=${$startYear}`
                        : `iac?grade=${$grade}`;

                spotCards = await fetchDataFromServer(viewPath);
                $spotType = spotTypeBeforeAPICall_lock;

                fetchDataResult = fetchDataResults.SUCCESS;
            } catch (error) {
                fetchDataResult = fetchDataResults.FAILURE;
            } finally {
                loading = false;
            }
        }
    };

    onMount(() => {
        fetchData();
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        return fetchData();
    };
</script>

<div
    class="flex flex-col items-center justify-center rounded-md bg-cyan-900 text-neutral-100 max-w-auto mb-3 p-5"
>
    <div class="text-center mb-5" cy_data="welcome-message">
        <p>Bem vinda (ou bem vindo) ao {appName}! 👋</p>
        <p>
            O formulário abaixo permite-te ver as vagas que terias disponíveis
            nos últimos anos para os concursos do Internato de Formação
            Especializada (<span class="font-bold">IFE</span>) e do Internato de
            Ano Comum (<span class="font-bold">IAC</span>).
        </p>
    </div>

    <SpotTypeSwitch />
    <Form {handleSubmit} />

    {#if fetchDataResult === fetchDataResults.USER_NOT_LOGGED_IN}
        <h2 id="LoginMessage" cy_data="login_message">
            <p>Por favor faz login para poderes ver os resultados!</p>
            <br />
            <p>
                Recomendamos que uses o login automático através da conta
                google, mas também te podes registar com email e password como
                se fazia no antigamente.
            </p>
        </h2>
    {:else if fetchDataResult === fetchDataResults.USER_EMAIL_NOT_VERIFIED}
        <h2 id="email-not-verified" cy_data="email-not-verified">
            <p>
                Por favor confirma o teu email para poderes ver os resultados!
            </p>
            <button
                id="resend-email"
                on:click={async () => {
                    await sendEmailVerification(auth.currentUser);
                    verificationEmailSent = true;
                }}
            >
                Clica aqui para reenviar o email de verificação
            </button>
            {#if verificationEmailSent}
                <p>Email reenviado!</p>
            {/if}
        </h2>
    {:else if loading}
        <h3 id="loading" class="flex justify-center text-xl text-neutral-100">
            A carregar
        </h3>
    {:else if fetchDataResult === fetchDataResults.SUCCESS}
        <SpotsDisplay {spotCards} />
    {:else}
        <h2 id="ErrorMessage">
            <p>Ups! Houve um erro a carregar as vagas. Tenta outra vez!</p>
            <p>
                Se o erro persistir, por favor contacta-nos através do nosso
                instagram
                <a href="https://www.instagram.com/vagasinternato.app/">
                    @vagasinternato.app
                </a>
            </p>
        </h2>
    {/if}
</div>

<style>
    #ErrorMessage,
    #LoginMessage,
    #email-not-verified {
        margin-top: 10pt;
        text-align: center;
    }

    #resend-email {
        margin-top: 0.75rem;
    }

    #loading::after {
        display: inline-block;
        animation: dotty steps(1, end) 2s infinite;
        content: "";
    }

    @keyframes dotty {
        0% {
            content: "";
        }
        17% {
            content: ".";
        }
        34% {
            content: "..";
        }
        51% {
            content: "...";
        }
        68% {
            content: "..";
        }
        85% {
            content: ".";
        }
        100% {
            content: "";
        }
    }
</style>
